import $ from 'jquery';
import toastr from 'toastr';
import 'owl.carousel';

function installLockfixedCompat(jQueryInstance) {
	if (typeof jQueryInstance.lockfixed === 'function') {
		return;
	}

	const defaults = {
		offset: {
			top: 0,
			bottom: 0,
		},
	};

	const applySticky = ($elements, options = {}) => {
		const settings = {
			...defaults,
			...options,
			offset: {
				...defaults.offset,
				...(options.offset || {}),
			},
		};

		$elements.each((_, element) => {
			if (!(element instanceof HTMLElement)) {
				return;
			}

			element.style.position = 'sticky';
			element.style.top = `${settings.offset.top}px`;
			element.style.alignSelf = 'flex-start';
		});

		return $elements;
	};

	jQueryInstance.lockfixed = (selector, options = {}) =>
		applySticky(jQueryInstance(selector), options);

	jQueryInstance.fn.lockfixed = function lockfixedCompat(options = {}) {
		return applySticky(this, options);
	};
}

export function bootstrapThemePlugins() {
	window.jQuery = $;
	window.$ = $;
	window.toastr = toastr;
	installLockfixedCompat($);

	return {
		$,
		toastr,
		window,
		document,
	};
}
